export default __webpack_public_path__ + "static/media/Point of Sale (1).88ae0a6f.jpg";